export const data = {
  'signedUpTitle': "You're now signed up with Rendezvous!",
  'signedUpContent': "We'll store your information for 30 days, but if your details or your contact's details " + 
    "change before the end of this period, just fill in our registration form again to make this change.",
  'whatsNextTitle': "What's Next?",
  'whatsNextContent': "If you'd like to know more about exactly what will happen in the case of an emergency, " +
    "how to start a session on the hill, or anything else about how Rendezvous works head to our 'how it works' page.",
};